<template>
    <s-modal 
        title=""
        :save="true"
        @save="saveInvite"
        :disabled="this.pseudo<2"
        :deleteData="joueur.id!=null && tournoi.state=='INSCRIPTION'"
        :close="true"
        @close="$emit('close')"
        :cancel="joueur.id==null"
        @cancel="$emit('close')"
        @delete="deleteInvite"
        :open="open"
        v-if="tournoi"
    >
        <div style="text-align:center;margin-bottom: 10px" v-if="tournoi.state=='INSCRIPTION'">
                <s-button @onclick="openAddInvites"
                    label="Ajouter plusieurs Invités"
                    icon="users"
                    theme="is-primary"/>
                        <hr/>
        </div>
        <div style="text-align:left;font-size:22px;font-weight:bolder;color:black">
            <s-l id="EditerOneInvite">Editer un joueur en tant qu'invité</s-l>
        </div>
        <div v-if="joueur && open">
            

            <div class="slabel">
                Nom : <s-input theme="is-primary"  v-model="joueur.nom" placeholder="Nom" />
                
            </div>
            <div class="slabel">
                Prénom : <s-input theme="is-primary"  v-model="joueur.prenom" placeholder="Prénom" />
            </div>
            <div class="slabel">
                Pseudo : <s-input theme="is-primary"  v-model="joueur.pseudo" :placeholder="pseudo" />
                 <div v-show="errorPseudo" class="errorField">
                    Ce pseudo est déjà utilisé
                </div>
            </div>
            <div class="slabel">
                Email : <s-input theme="is-primary"  v-model="joueur.email" placeholder="Email" />
                <div v-show="emailError" class="errorField">
                    Cet email est déjà utilisé par un des joueurs
                </div>
                <div v-show="emailFormatError" class="errorField">
                    Le format d'email n'est pas bon : ***@*****.***
                </div>
            </div>
            <div style='float:right;margin-top: 10px;'>
                Le sauvegarder en tant que membre :
                <div style="text-align:right">
                <s-switch id="demo" 
                            label-enable-text="OUI"
                            label-disable-text="NON"
                            :defaultState="invite"
                            @change="inviteToMembre"
                />
                </div>
            </div>
        </div>
   </s-modal>
</template>
<style scoped>
    .errorField {
        color: red;
    }
</style>
<script>
import tournoi_fct  from '@/firebase/tournoi'
import joueur_fct   from '@/firebase/joueur'
import club_fct  from '@/firebase/club'
import firebase_api  from '@/firebase/firebase_api'
const { v4: uuidv4 } = require('uuid');
export default {
    props: ['joueur', 'open', 'joueurs', 'tournoi', 'club'],
    computed: {
        pseudo: {
            get() {
                if (this.joueur!=null)
                    return joueur_fct.object.calculPseudo(this.joueur)
                else
                    return "";
            }
        }
    },
    watch: {
        open() {
            this.emailError = false;
            if (typeof(this.joueur.invite)=="undefined")
                this.invite = false;
            else
                this.invite = !this.joueur.invite;
        }
    },
    data() {
        return {
            emailError: false,
            emailFormatError: false,
            errorPseudo: false,
            invite: false
        }
    },
    methods: {
        openAddInvites() {
            this.$emit("OpenModalInvites");
        },
        inviteToMembre() {
            if (this.joueur.id != null)
                this.deleteInvite();
            this.$emit("inviteToMembre")
        },
        async saveInvite() {
            this.emailError = false;
            this.emailFormatError = false;
            this.errorPseudo = false;
            if (this.joueur.email!='') {
                this.emailFormatError = joueur_fct.object.verifEmail(this.joueur.email);
                if (!this.emailFormatError) {
                    var index = this.joueurs.findIndex(joueur=>joueur.email === this.joueur.email);
                    if (index!=-1)
                        this.emailError = this.joueurs[index].id != this.joueur.id;
                    else
                        this.emailError = index != -1;
                }
                
            }
            var pseudoSearch = (this.joueur.pseudo == '' || typeof(this.joueur.pseudo)=="undefined") ? this.pseudo : this.joueur.pseudo;
            var indexJoueurByPseudo = this.joueurs.findIndex(joueur=>joueur.pseudo === pseudoSearch)
            this.errorPseudo = indexJoueurByPseudo != -1;

            if (!this.emailError && !this.emailFormatError && !this.errorPseudo) {
                if (this.joueur.id == null) {
                    this.joueur.id = uuidv4();
                    this.joueur.invite = true;
                    this.joueurs.push(this.joueur);
                    if (typeof(this.tournoi.preinscription)=="undefined") {
                        this.tournoi.preinscription = [];
                    }
                    this.tournoi.preinscription.push(this.joueur.id);
                    if (typeof(this.tournoi.invites)=="undefined") {
                        this.tournoi.invites = {};
                    }
                }
                if (this.joueur.pseudo == '' || typeof(this.joueur.pseudo)=="undefined")
                    this.joueur.pseudo = this.pseudo;
                
                this.tournoi.invites[this.joueur.id] = JSON.parse(JSON.stringify(this.joueur));
            
                tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                
                })
                if (this.joueur.email!='') {
                    var batch = firebase_api.api.getDb().batch();
                    club_fct.object.addUser(this.joueur, this.club, batch, this.tournoi.id).then(user=>{
                        batch.commit();
                    });
                }
                this.$emit("saved", this.joueur);
                this.$emit("refresh");
                this.$emit("close");
                
            }
        },
        deleteInvite() {
            delete this.tournoi.invites[this.joueur.id];
            if (typeof(this.tournoi.preinscription)!="undefined") {
                var index = this.tournoi.preinscription.indexOf(this.joueur.id);
                this.tournoi.preinscription.splice(index,1);
            }
            tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                
            })
            if (this.joueur.email!='')
                club_fct.object.deleteInvite(this.joueur, this.club, this.tournoi.id);
            this.$emit("refresh");
            this.$emit("close");
        },
    }
}
</script>